import { render, staticRenderFns } from "./PublicAthleteSideNavLayout.vue?vue&type=template&id=a61f7c7e&"
import script from "./PublicAthleteSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./PublicAthleteSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports